import { useQuery } from '@tanstack/react-query';

import { api } from 'api';

export function useHireflixEnabled(jobId: number) {
  const query = useQuery({
    queryKey: ['hireflixEnabled', jobId],
    queryFn: () => api.integrations.hireflixJobEnabled(String(jobId)),
    staleTime: 1000 * 60 * 60,
  });

  return query.isSuccess && query.data.positionId;
}
